import '@fingo/lib/assets/fonts/itau/fonts.css';
import { esES as coreES } from '@mui/material/locale';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid';
import breakpoints from '@fingo/lib/theme/breakpoints';
import components from '@fingo/lib/theme/fingo/components';
import itauComponents from '@fingo/lib/theme/itau/components';
import palette from '@fingo/lib/theme/itau/palette';
import typography from '@fingo/lib/theme/itau/typography';
import branding from '@fingo/lib/theme/fingo/branding';

const theme = createTheme(
  {
    palette,
    breakpoints,
    typography,
    components: {
      ...components,
      ...itauComponents,
    },
    branding,
  },
  coreES,
  esES,
);

export default responsiveFontSizes(theme);
